import { render, staticRenderFns } from "./SetVipDialog.vue?vue&type=template&id=0b02b692&scoped=true"
import script from "./SetVipDialog.vue?vue&type=script&lang=js"
export * from "./SetVipDialog.vue?vue&type=script&lang=js"
import style0 from "./SetVipDialog.vue?vue&type=style&index=0&id=0b02b692&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b02b692",
  null
  
)

export default component.exports